import React from 'react'
import LogoImg from '../../../assets/login/logo.png'
import { Img, Container, Logo, LogoDiv } from './style'
import { Phrase, Phrase2 } from './style'
// import { Logo } from '../style'






const SuccessMsg: React.FC = () => {
    return (
        <>
            <Img>
            </Img>
            <Container>
                <LogoDiv>
                    <Logo src={LogoImg} alt='Logo da Dustre'/>
                </LogoDiv>
                <Phrase>
                    <h2>Seu cadastro foi enviado com sucesso!</h2>
                </Phrase>
                <Phrase2>
                    <p>Recebemos suas informações e estamos processando seu cadastro.Assim que for aprovado,você receberá um email de confirmação com instruções para acessar nossa plataforma.</p>
                </Phrase2>
            </Container>
        </>
    )
}

export default SuccessMsg